/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: CA
 *| (C) Copyright IBM Corp. 2017 - 2020
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */
define([
	'../../lib/@waca/core-client/js/core-client/ui/core/Class',
	'./MenuActionHelper'
], function (BaseClass, MenuActionHelper) {
	'use strict';

	var DoMoreActionHandler = BaseClass.extend({
		init: function (options) {
			DoMoreActionHandler.inherited('init', this, arguments);
			this.dashboardApi = options.dashboardApi;
			this.dataSource = options.dataSource;
		},

		/**
		 * Do More button event handler. Called when the Do More button is clicked or tapped.
		 */
		execute: function (evt) {
			MenuActionHelper.getActionPayload({
				'dashboardApi': this.dashboardApi,
				'id': this.dataSource.getAssetId(),
				'type': this.dataSource.getType(),
				'event': evt,
				'menuId': 'com.ibm.bi.dashboard.dataSources.dataSourceActionsMenu'
			}).then(function(payload) {
				payload.activeObject.dataSource = this.dataSource;
				this.dashboardApi.showContextMenu(payload);
			}.bind(this));

			return false;
		}
	});

	return DoMoreActionHandler;
});
